import { Bell } from 'lucide-react';
import { toast } from 'react-toastify';

/** Toast after bulk retry of failed account-import tasks (retry_session). */
export function showRetryImportFailedRequestToast(): void {
    toast.info('Đã gửi yêu cầu tạo lại tài khoản import lỗi', {
        icon: () => (
            <Bell size={20} className="text-primary shrink-0" aria-hidden />
        ),
        style: { width: 'max-content', maxWidth: 'calc(100vw - 2rem)' },
        className: 'items-center',
        bodyClassName: '!mb-0 flex items-center whitespace-nowrap text-sm',
    });
}
